/**
 * Thrown when the file fetch inside {@link secureDownload} returns a non-ok
 * HTTP status. Carries the numeric `status` so callers can classify the
 * failure (e.g. 403 forbidden vs 404/410 gone vs transient) the same way they
 * classify an API/mint error, rather than collapsing every download failure
 * into a single generic bucket.
 */
export class SecureDownloadError extends Error {
  readonly status: number;

  constructor(status: number) {
    super(`Download failed: HTTP ${status}`);
    this.name = 'SecureDownloadError';
    this.status = status;
  }
}

export async function secureDownload(url: string, filename: string): Promise<void> {
  const response = await fetch(url);
  if (!response.ok) throw new SecureDownloadError(response.status);
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  try {
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } finally {
    URL.revokeObjectURL(blobUrl);
  }
}
